import React from "react"
import Helmet from "react-helmet"

const PageMetadata = ({ pagePathname, pageTitle, pageDescription, pageContent }) => {
    //pageContent is strictly optional

    let socialMetadata = {
        "og:url": "https://disruptionresearch.firebaseapp.com" + pagePathname, // only set once by arguments. hould also be canonical

        "og:title": typeof pageTitle !== "undefined" ? pageTitle + " | Disruption Research" : "Disruption Research", // sets default value if no argument
        "og:description":
            pageDescription || "Producing best-in-class research on the most innovative companies in the stock market", // sets default value if no argument

        "og:image": "https://disruptionresearch.firebaseapp.com/defaultsocialcard.png", // will be overriden if pageContent exists
        "og:type": "website", // will be overriden if pageContent exists

        // constant values
        "og:site_name": "Disruption Research",
        "og:locale": "en_US", // may need rework
        "twitter:card": "summary_large_image",
        "twitter:site": "@DisruptResearch",
        "twitter:creator": "@DisruptResearch",
    }

    if (pageContent) {
        //rewrite values if pageContent argument exists
        Object.assign(socialMetadata, {
            "og:title": pageContent.seoTitle + " | Disruption Research",
            "og:description": pageContent.seoDescription,
            "og:image": "https:" + pageContent.ogImage.file.url,
            "og:type": "article",
        })
    }

    const metaArray = [{ name: "description", content: socialMetadata["og:description"] }] //initiate a metaarray with one object containing description = "X", content = "Y"

    for (const key in socialMetadata) {
        //push socialmetadata values with property= "X", content = "Y" format. note Twitter default key is "name" instead of "property" but they have fallback
        metaArray.push({
            property: key,
            content: socialMetadata[key],
        })
    }

    return (
        //return helmet with title tag, link canonical tag, and all metadata
        <Helmet
            htmlAttributes={{ lang: "en" }}
            title={socialMetadata["og:title"]}
            link={[{ rel: "canonical", href: socialMetadata["og:url"] }]}
            meta={metaArray}
        />
    )
}

export default PageMetadata
